import { compose } from 'recompose';

import UserShow from './UserShow';

const enhance = compose();

export default enhance(UserShow);
